import {
  CREATE_ALERT_V3,
  EDIT_ALERT_V3,
} from "fleet/redux-store/alerts-v3/actions";
import { LOAD_EVENTS_V3_NAME } from "fleet/redux-store/ui-state/events-v3/actions";
import { AlertV3FormPage } from "fleet/view/alert/form-v3";
import { connect } from "react-redux";
import { isStoreReady, makeGetAllAsArray } from "redux-store";
import { createPromiseApiAction } from "redux-store/api-sagas";
import { compatApplicationsSelector } from "redux-store/applications/selectors";
import { devicesSelector } from "redux-store/devices/selectors";
import { usersSelector } from "redux-store/users/selectors";
import { getTargetOptions } from "util/get-target-options";

const getAppsAsArray = makeGetAllAsArray();
const getUsersAsArray = makeGetAllAsArray();

function mapStateToProps(state) {
  const storesLoaded = isStoreReady(
    state.global.applications,
    state.global.devices,
    state.global.users,
  );
  const devices = devicesSelector(state);
  const appsById = compatApplicationsSelector(state);
  const apps = getAppsAsArray({ byId: appsById });
  const usersByID = usersSelector(state);
  const users = getUsersAsArray({ byId: usersByID });
  const targetOpts = getTargetOptions(devices);

  return {
    apps,
    storesLoaded,
    users,
    targetOpts,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    newAlert: (serviceArgs) => {
      const { name, eventNames, targets, users, params } = serviceArgs;
      return createPromiseApiAction(dispatch, CREATE_ALERT_V3, [
        name,
        eventNames,
        targets,
        users,
        params,
      ]);
    },

    editAlert: (serviceArgs) => {
      const { id, name, eventNames, targets, users, params } = serviceArgs;
      return createPromiseApiAction(dispatch, EDIT_ALERT_V3, [
        id,
        name,
        eventNames,
        targets,
        users,
        params,
      ]);
    },

    loadEventsV3Name: () => {
      return createPromiseApiAction(dispatch, LOAD_EVENTS_V3_NAME);
    },
  };
}

const ConnectedAlertV3New = connect(
  mapStateToProps,
  mapDispatchToProps,
)(AlertV3FormPage);

export { ConnectedAlertV3New };
